export type GamePartnerFormKey = 'game_name';

const gamePartnersListMap = [
	{
		label: 'Skin Id',
		value: 'skinid',
	},
	{
		label: 'Skin Name',
		value: 'name',
	},
	{
		label: 'External ID',
		value: 'external_id',
	},
	{
		label: 'Partner Name',
		value: 'partner_name',
	},
	{
		label: 'Partner Id',
		value: 'partnerid',
	},
];

const columnFormatter = {
	name: 'value',
	gid: 'value',
	// game_partner_master: 'master',
};

const formNameMap = {
	name: 'Game name',
};

export { gamePartnersListMap, columnFormatter, formNameMap };
